export default "__VITE_ASSET__B5ciQ9yw__ 100w";